import { TEAM_PERIODS, type TeamPeriod } from '../../lib/teamPeriod';

export function TeamPeriodSelect({
  value,
  onChange,
}: {
  value: TeamPeriod;
  onChange: (period: TeamPeriod) => void;
}) {
  return (
    <div className="w-full sm:w-48" data-tour="team-period">
      <label htmlFor="team-period" className="block text-sm font-medium text-gray-700 mb-1">
        Period
      </label>
      <select
        id="team-period"
        value={value}
        onChange={(e) => onChange(e.target.value as TeamPeriod)}
        className="w-full border rounded-md px-3 py-2 text-sm bg-white border-gray-300"
      >
        {TEAM_PERIODS.map((p) => (
          <option key={p.value} value={p.value}>
            {p.label}
          </option>
        ))}
      </select>
    </div>
  );
}
